<template>
  <v-card elevation="4" class="rounded-sm">
    <v-card-title>
      <div class="text-subtitle-1 font-weight-bold">Procedimientos</div>
      <v-spacer></v-spacer>
      <v-btn
        fab
        color="secondary"
        icon
        v-if="!readonly"
        @click="
          $emit('add-procedimiento', {
            id: null,
            idEstatus: null,
            numero: '',
            fecha: '',
            motivo: '',
            descripcion: '',
            resolucion: '',
            estatus: true,
            idProcedimiento: null,
          })
        "
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" v-for="(procedimiento, index) in procedimientos" :key="index">
            <v-row>
              <v-col>
                <div class="text-h6">{{ index + 1 }}</div>
              </v-col>
              <v-col cols="10">
                <v-row>
                  <v-col cols="2">
                    <v-select
                      label="Tipo de procedimiento"
                      v-model="procedimiento.idProcedimiento"
                      :items="catalogoProcedimientos"
                      item-value="id"
                      item-text="title"
                      item-color="secondary"
                      rounded
                      filled
                      dense
                      color="secondary"
                      background-color="primary"
                      :readonly="readonly"
                    ></v-select>
                  </v-col>
                  <v-col>
                    <v-text-field
                      label="Número"
                      v-model="procedimiento.numero"
                      rounded
                      filled
                      dense
                      color="secondary"
                      background-color="primary"
                      :readonly="readonly"
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-menu
                      v-model="menuFecha[index]"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="procedimiento.fecha"
                          label="Fecha"
                          append-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          rounded
                          filled
                          dense
                          color="secondary"
                          background-color="primary"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="procedimiento.fecha"
                        @input="menuFecha[index] = false"
                        :readonly="readonly"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col>
                    <v-text-field
                      label="Motivo"
                      v-model="procedimiento.motivo"
                      rounded
                      filled
                      dense
                      color="secondary"
                      background-color="primary"
                      :readonly="readonly"
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-select
                      label="Estado actual"
                      v-model="procedimiento.idEstatus"
                      :items="estatusProcedimiento"
                      item-value="id"
                      item-text="title"
                      item-color="secondary"
                      rounded
                      filled
                      dense
                      color="secondary"
                      background-color="primary"
                      :readonly="readonly"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <v-textarea
                      label="Descripción"
                      v-model="procedimiento.descripcion"
                      rounded
                      filled
                      dense
                      color="secondary"
                      background-color="primary"
                      rows="2"
                      no-resize
                      :readonly="readonly"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="6">
                    <v-textarea
                      label="Resolución"
                      v-model="procedimiento.resolucion"
                      rounded
                      filled
                      dense
                      color="secondary"
                      background-color="primary"
                      rows="2"
                      no-resize
                      :readonly="readonly"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-btn small color="error" class="mt-2" text v-if="!readonly" @click="procedimiento.estatus = false">
                  Eliminar
                </v-btn>
              </v-col>
            </v-row>
            <v-divider></v-divider>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    procedimientos: {
      type: Array,
      required: true,
    },

    readonly: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      menuFecha: [],
    }
  },

  computed: {
    ...mapGetters('procedimiento', { catalogoProcedimientos: 'getProcedimiento' }),
    ...mapGetters('estatusProcedimiento', { estatusProcedimiento: 'getEstatusProcedimiento' }),
  },
}
</script>
